<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="message-card" v-if="false">
				<div class="header">
					<div class="tabbar">
						<div class="item" @click="textClick(index)" :class="{ active: count == index }" v-for="(item, index) in newContenList">
							<div class="txt">{{ item }}</div>
							<div class="line"></div>
						</div>
					</div>
					<div class="more" @click="moreClick()">查看更多></div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in textList" @click="contentClick(item.id)">
						<div class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
						<div class="date" v-if="item.createTime">更新日期 {{ item.createTime.slice(0, 10) }}</div>
					</div>
				</div>
			</div>
			<div class="project-list">
				<div class="header">
					<div class="item active">
						<div class="txt">产品介绍</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="list">
					<a href="javascript:void(0);" class="item" v-for="(item, index) in productList" @click="viewDetail(item)">
						<img :src="webImg + item.productImage + imgCut(345, 242)" alt="" @dragstart.prevent />
						<div class="txt-ellipsis-1">{{ item.productTitle }}</div>
					</a>
				</div>
			</div>
			<div class="project-list">
				<div class="header">
					<div class="item active">
						<div class="txt">业务领域</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="list">
					<a href="javascript:void(0);" class="item" v-for="(item, index) in engineeringList" @click="openEngineering(item)">
						<img :src="webImg + item.contentImg + imgCut(345, 242)" alt="" @dragstart.prevent />
						<div class="txt-ellipsis-1">{{ item.contentTitle }}</div>
					</a>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="home">
				<div class="about-us">
					<div class="left-block">
						<div class="heading">关于我们</div>
						<div class="eng">ABOUT US</div>
						<div class="des">流体机械事业部专注于从事石油、化工、能源、环保、煤化工等行业用泵与喷射技术研究及相关产品的设计研制、测试分析、装备成套、能效评估、故障诊断等工作。先后自主研发出系列离心式化工流程泵、往复式泵、高精度计量泵及加药装置、无泄漏泵、特种泵等产品;开发出系列高精度智能型泵试验装置，可完成多种泵型的型式试验、出厂试验、寿命试验、整泵故障预判失效模式试验、易损件高效模拟寿命试验等，致力解决我国工业领域众多高危险、高难度工业清洗、表面除层、特种切割与破拆等重大工程难题，先后开发出多种国产首台套装备，成果广泛应用于大型储罐机械清洗、机场跑道除胶、船舶及储罐外壁除锈、特种水切割与水力破拆等领域，填补了我国多项产品和应用空白，整体技术达到国际先进水平。</div>
						<div class="btn-more" @click="toAboutUs">
							查看更多 >
						</div>
					</div>
					<div class="right-block">
						<div class="pic">
							<img src="../assets/008.png" alt="" @dragstart.prevent />
						</div>
					</div>
				</div>
				<!-- <div class="content">
					<div class="left" style="width: 650px;">
						<el-carousel trigger="click" height="386px" indicator-position="none">
							<el-carousel-item v-for="(item, index) in textImgList" :key="index">
								<div style="position: relative;cursor: pointer;">
									<img :src="webImg + item.contentImg + imgCut(650, 356)" alt="" srcset=""
										@dragstart.prevent style="width: 650px;!important; height: 386px;"
										@click="contentClick(item.id)">
									<div class="leftText">
										<div>{{ filterUnit(item.contentTitle) }}</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="right">
						<div class="newContent">
							<div class="text">
								<div class="textItem" @click="textClick(index)" :class="{ textItem1: count == index }"
									v-for="(item, index) in newContenList">{{ item }}</div>
							</div>
							<div class="more" @click="moreClick()">更多 >></div>
						</div>
						<div class="newMain">
							<div class="newMainItem" v-for="(item, index) in textList" @click="contentClick(item.id)">
								<div class="newMainDescription ">{{ filterUnit(item.contentTitle) }}</div>
								<div class="time" v-if="item.createTime">[{{ item.createTime.slice(0, 10) }}]</div>
							</div>
						</div>
					</div>
				</div> -->
				<!-- 产品介绍 -->
				<div class="engineering">
					<div class="engineeringName">
						<div>产品介绍</div>
						<div class="line"></div>
					</div>
					<div class="engineeringMain">
						<a style="cursor: default" href="javascript:void(0);" class="engineeringMainItem" v-for="(item, index) in productList" @click="viewDetail(item)">
							<img :src="webImg + item.productImage + imgCut(310, 225)" alt="" @dragstart.prevent />
							<div class="txt-ellipsis-1">{{ filterUnit(item.productTitle) }}</div>
						</a>
					</div>
				</div>
				<!-- 业务领域 -->
				<div class="engineering">
					<div class="engineeringName">
						<div>业务领域</div>
						<div class="line"></div>
					</div>
					<div class="engineeringMain">
						<a href="javascript:void(0);" class="engineeringMainItem" v-if="index < 4" v-for="(item, index) in engineeringList" @click="openEngineering(item)">
							<img :src="webImg + item.contentImg + imgCut(310, 225)" alt="" @dragstart.prevent />
							<div class="txt-ellipsis-1">{{ filterUnit(item.contentTitle) }}</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { contentPage, businessList, CmsProductList } from '../api/api';
export default {
	name: 'homeTemplate',
	data() {
		return {
			newsList: [],
			textImgList: [],
			newContenList: ['新闻动态', '通知公告'],
			count: 0,
			textList: [],
			engineeringList: [],
			productList: []
		};
	},
	created() {
		this.getCmsProductList(); //产品介绍
		this.getContentPage(2142); //业务领域
		this.getNewsPage(2143); //新闻动态
		this.getNewImgPage(2143); //新闻动态
	},
	methods: {
		// 产品介绍跳转详情
		viewDetail(item) {
			let viewInfo = {
				title: item.productTitle,
				content: item.productContent,
			}
			this.$router.push({
				path: '/detail',
				query: {
					'viewInfo': viewInfo,
				}
			})
		},
		// 业务领域跳转
		openEngineering(item) {
			if (item.contentUrl) {
				let url = item.contentUrl;
				if (url.indexOf('#') !== -1) {
					url = url.substring(url.indexOf('#') + 1);
				}
				this.$router.push(url);
			}
		},
		// 跳转关于我们
		toAboutUs() {
			this.openUrl({
				path: '/aboutUs',
				query: {
					parentId: 2069,
					index: 1,
					num: 0
				}
			});
		},
		// 获取首页产品列表
		getCmsProductList() {
			CmsProductList().then((res) => {
				this.productList = res.data;
			});
		},

		filterUnit(item) {
			return item.replace(/<br>/g, '');
		},

		newsImgClick() {
			console.log(1111111);
		},
		//
		textClick(index) {
			this.count = index;
			if (index == 0) {
				this.getNewsPage(2143); //新闻动态
			} else {
				this.getNewsPage(2128); //通知公告
			}
		},
		//新闻动态
		contentClick(id) {
			if (this.count == 0) {
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 0,
						contentId: id
					}
				});
			} else {
				console.log(this.count, 'this.count');
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 1,
						contentId: id
					}
				});
			}
		},
		moreClick(id) {
			if (this.count == 0) {
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 0
					}
				});
			} else {
				console.log(this.count, 'this.count');
				this.$router.push({
					path: '/newsCenter',
					query: {
						parentId: 2057,
						index: 1,
						num: 1
					}
				});
			}
		},
		getContentPage(id) {
			contentPage(1, 1000, id).then((res) => {
				this.engineeringList = res.data;
			});
		},

		getNewsPage(id) {
			contentPage(1, 9, id, '', 1).then((res) => {
				this.textList = res.data;
			});
		},
		getNewImgPage(id) {
			contentPage(1, 5, id, '', 1, '', 1).then((res) => {
				this.textImgList = res.data.filter((item) => item.contentImg);
			});
		},
		getImg(list) {
			if (list && list.length > 0) {
				let arrList = [];
				list.forEach((item, index) => {
					if (item.contentImg) {
						arrList.push(item);
					}
				});
				return arrList;
			} else {
				return [];
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.message-card {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tabbar {
				display: flex;
				align-items: center;

				.item {
					position: relative;
					display: flex;
					flex-direction: column;
					margin-right: 0.4rem;

					&.active {
						.txt {
							font-size: 0.453333rem;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: bold;
							color: #000000;
						}

						.line {
							display: block;
						}
					}

					.txt {
						font-size: 0.4rem;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #000000;
					}

					.line {
						position: absolute;
						bottom: -0.266667rem;
						display: none;
						margin-top: 0.213333rem;
						width: 1.2rem;
						height: 0.053333rem;
						background: #007cc3;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
					}
				}
			}

			.more {
				font-size: 0.346667rem;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #007cc3;
			}
		}

		.list {
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.item {
				width: 100%;
				box-sizing: border-box;
				padding: 0.4rem;
				border-bottom: 0.026667rem solid #eeeeee;

				.title {
					font-size: 0.4rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 0.533333rem;
				}

				.date {
					margin-top: 0.266667rem;
					font-size: 0.266667rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		}
	}

	.project-list {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007cc3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.item {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.266667rem;
				text-decoration: none;

				img {
					width: 4.6rem;
					height: 3.226667rem;
				}

				div {
					width: 4.6rem;
					margin: 0.266667rem 0;
					font-size: 0.346667rem;
					font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #004ea1;
					text-align: center;
				}
			}
		}
	}
}

.device-pc {
	.home {}
	
	.about-us {
		max-width: 1300px;
		width: 100%;
		margin: 0 auto;
		display: flex;
		.left-block {
			margin-top: 70px;
			width: 656px;
			.heading {
				height: 40px;
				font-weight: bold;
				font-size: 40px;
				color: #1673C3;
				line-height: 40px;
			}
			.eng {
				margin-top: 20px;
				height: 22px;
				font-weight: bold;
				font-size: 22px;
				color: #1673C3;
				line-height: 22px;
			}
			.des {
				margin-top: 20px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				line-height: 35px;
				text-align: justify;
				text-indent: 2em;
			}
			.btn-more {
				margin-top: 20px;
				margin-bottom: 40px;
				width: 149px;
				height: 46px;
				border-radius: 30px 30px 30px 30px;
				border: 1px solid #0175C2;
				display: flex;
				justify-content: center;
				align-items: center;
				font-weight: 500;
				font-size: 18px;
				color: #0175C2;
				line-height: 18px;
				cursor: pointer;
			}
		}
		.right-block {
			margin-left: auto;
			.pic {
				margin-top: 127px;
				width: 527px;
				height: 337px;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
					transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
				}
			}
			.pic:hover {
				img {
					transform: scale(1.1);
				}
			}
		}
	}

	.left {
		overflow: hidden;

		.leftText {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 40px;

			div {
				width: 500px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
				text-align: center;
				// display: flex;
				// justify-content: center;
				// align-items: center;
			}

			font-size: 16px;
			font-weight: normal;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			background: rgba(0, 0, 0, 0.4);
		}
	}

	.content {
		max-width: 1300px;
		width: 100%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		padding-bottom: 20px;
	}

	.right {
		width: 650px;
		height: 386px;
		// height: 485px;
		// box-shadow: -5px 4px 5px 0px rgba(153, 153, 153, 1);
		box-sizing: border-box;
		border: 1px solid #e6e3e3;
		border-left: none;
		box-sizing: border-box;

		.newContent {
			height: 49px;
			border-bottom: 1px solid #e6e3e3;
			display: flex;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;
		}

		.text {
			display: flex;
			align-items: center;

			.textItem {
				font-size: 20px;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				cursor: pointer;
			}

			.textItem:first-child {
				margin-right: 48px;
			}

			.textItem1 {
				font-size: 20px;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #0175c2;
			}
		}

		.more {
			font-size: 14px;
			font-family: PingFang SC-Semibold, PingFang SC;
			font-weight: 600;
			color: #b6b6b6;
			margin-left: auto;
			margin-top: 5px;
		}

		.newMain {
			padding: 0 20px;
			box-sizing: border-box;

			.newMainItem {
				height: 36px;
				color: #333333;
				width: 700px;
				// text-indent: 20px;
				display: block;
				line-height: 36px;
				font-size: 15px;

				display: flex;
				align-items: center;
				cursor: pointer;

				.newMainDescription {
					width: 500px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.time {
					// font-size: 13px;
					// font-family: PingFang SC-Semibold, PingFang SC;
					// font-weight: 600;
					// color: #000000;
					margin-left: 20px;
				}
			}
		}
	}

	.engineering {
		width: 100%;
		// height: 1393px;
		background: #f5f5f5;

		.engineeringName {
			font-size: 32px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #000000;
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 130px;
			justify-content: center;

			.line {
				width: 55px;
				height: 2px;
				background: #c2c2c2;
				margin-top: 10px;
			}
		}
	}

	.engineeringMain {
		display: flex;
		flex-wrap: wrap;
		width: 1300px;
		margin: 0 auto;

		a {
			color: #004ea1;
			text-decoration: none;
			text-align: center;
		}

		// justify-content: space-between;

		.engineeringMainItem {
			font-size: 20px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #004ea1;
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
			align-items: center;
			// margin-bottom: 50px;
			margin-right: 10px;
			overflow: hidden;

			img {
				width: 310px;
				height: 225px;
				margin-bottom: 20px;
				object-fit: fill;
				cursor: pointer;
				transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
			}
			
			div {
				width: 310px;
			}
		}

		.engineeringMainItem:hover {
			img {
				transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
				transform: scale(1.1);
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue